module.exports = __webpack_public_path__ + "static/media/bank14.3ad2f9a5.png";